<template>
  <div class="one-column-width">



    <!-- form start -->
    <v-card class="r_tabsform_card mb-5" >
    <v-card-title class="r_form_card_title ext_pdg_to_lvl"> Find Job</v-card-title>
    <hr class="r_form_card_top_hr">

    <div class="col-md-11  m-5">
        <div class="col-md-12 row">
        <div class="col-md-6">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="Job Keyword" />
        </div>

        <div class="col-md-6">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="JobType" />
        </div>

        <div class="col-md-6">
            <!-- <label>Name <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="Country" />
        </div>

        <div class="col-md-6">
            <!-- <label>Institute <span class="text-danger">*</span></label> -->
            <input class="r_formtabs_inputs m-0 w-100" placeholder="City" />
        </div>

        <div class="col-md-3 pt-2">
            <button
                type="button"
                class="r_form_add_more_btnnn m-0"
            >
                Search
            </button>
        </div>
        
        
        </div>
    </div>
    <br />
    </v-card>
    <!-- form end -->

    <!-- table start -->
    <v-card class="r_tabsform_card">
      <v-card-title class="r_form_card_title">
        Search Result

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>      
        <v-text-field
          v-model="search"
          append-icon="search"
          class="r_form_top_search"
          label="Search Uni Mates"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <hr class="r_form_card_top_hr">

      <v-data-table class="r_admn_dashboad_tdss" :headers="headers" :items="tableData" :search="search" loading>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="btn btn-sm btn-light font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showEditForm(item)"
          >
            <v-icon class="text-primary">mdi-eye</v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            class="btn btn-sm btn-light font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="askUserAboutDelete(item)"
          >
            <v-icon class="text-danger">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- table end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      editId: null,
      deleteId: null,
      dialog: false,
      snackbar: false,
      snackBarText: null,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      applicationValues:null,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "",
          width: "20%",
          class: "r_admn_dashboad_title"
        },
        { text: "Photo", align: "left", sortable: false, value: "", width: "20%", class: "r_admn_dashboad_title" },
        { text: "Institute", align: "left", sortable: false, value: "", width: "20%", class: "r_admn_dashboad_title" },
        
        { text: "Department", align: "left", sortable: false, value: "", width: "20%", class: "r_admn_dashboad_title" },

        { text: "Actions", value: "actions", sortable: false, class: "r_admn_dashboad_title" },
      ],
      tableData: [],
    };
  },
  components: {},

   computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    getInititalData() {
      AdmissionForm.getStudentApplications()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // main methods
    showEditForm(item) {
      this.applicationValues = JSON.parse(item.values);
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.showFormData = false;
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      CampusService.deleteCampus(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Campus Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();
  },
};
</script>

<style scoped>
.text-success {
    color: #2eca8b !important;
}
.text-danger {
    color: #a82511 !important;
}

</style>
